import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ControlFactory from '@/Factories/ControlFactory';

export default class PDPrincipalUIListener extends UIListener {

    constructor() {
        super();
    }

    public onPropertyValueUpdated(context: DetailViewContext, property: string): void {
        this.updateGUI(context);
    }

    public onDetailViewReady(context: DetailViewContext): void {
        this.updateGUI(context);
    }

    private updateGUI(context: DetailViewContext): void {
        let defaultCurrencyEnabled = context.genericObject.getObservable('IsDefaultPrincipalCurrencyEnabled');
        let defaultCurrencyItem = context.getUIFactory('DefaultCurrency') as ControlFactory;
        let currentCurrencyItem = context.getUIFactory('CurrentCurrency') as ControlFactory;

        if (defaultCurrencyEnabled() === true) {
            defaultCurrencyItem.isVisible(true);
            currentCurrencyItem.isVisible(false);
        } else {
            defaultCurrencyItem.isVisible(false);
            currentCurrencyItem.isVisible(true);
        }

        defaultCurrencyItem.isRequired(true);
    }
}

ComponentManager.setUIListener('PDPrincipalUIListener', PDPrincipalUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.PDPrincipalUIListener', PDPrincipalUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');